/**
 * TerminationPendingChip - the header chip «Kündigung eingegangen, Freigabe ausstehend» of a customer whose
 * Mandatsauflösung is eröffnet or in Prüfung (P6, UC1/UC3). With the task the api names (the Prüfaufgabe
 * while in Prüfung, else the Freigabe task) the chip opens that task in the Aufgaben.
 */

import { Link } from '@tanstack/react-router';
import { Badge } from '../../../components/ui/Badge';

export const TERMINATION_PENDING_LABEL = 'Kündigung eingegangen, Freigabe ausstehend';

export function TerminationPendingChip({ taskId }: { taskId: string | null }) {
  const chip = (
    <Badge variant="warning" data-testid="termination-pending-chip">
      {TERMINATION_PENDING_LABEL}
    </Badge>
  );
  if (taskId === null) return chip;
  return (
    <Link to="/aufgaben" search={{ task: taskId }} aria-label={`${TERMINATION_PENDING_LABEL}: Aufgabe öffnen`} className="hover:opacity-80">
      {chip}
    </Link>
  );
}
